import PageBuilderRow from '../pageBuilderRow/PageBuilderRow';

export default {

  name: 'page-builder-block',

  props: {
    block: {}
  },

  data () {
    return {
      blockModel: {}
    };
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/PageBuilderBlock.js